import React from 'react';

interface ManualIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const ManualIcon: React.FC<ManualIconProps> = ({ height, width, color = '#FFD700' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M179.06 44a120.29 120.29 0 0 0-24.47 238l-2.66-3.56a45 45 0 0 1-5-8.7 110.36 110.36 0 1 1 118.77-37.31c.83-.06 1.67-.08 2.51-.08a43.3 43.3 0 0 1 9.25 1A120.22 120.22 0 0 0 179.06 44"
      ></path>
      <path
        style={{ fill: color }}
        d="M158.22 212.87a19.75 19.75 0 0 1-4.55-11.75h-22.22q0 14.94 10.56 24a39.6 39.6 0 0 0 7.14 4.91 42 42 0 0 1 11.6-12.87c.48-.35 1-.69 1.45-1a16.2 16.2 0 0 1-3.98-3.29m56.1-33a31.5 31.5 0 0 0-12.93-10 135 135 0 0 0-19.85-6.1v-39.33a19.4 19.4 0 0 1 10.19 6.1 18 18 0 0 1 4.38 10.11h22.22q-1.28-15.12-11-23.77t-25.77-10.11V92H169.7v14.75q-17.13 1.65-27.69 11.57t-10.56 25q0 12 5.37 19a31.76 31.76 0 0 0 13 10.1 147 147 0 0 0 19.86 6.29v33.46a41.6 41.6 0 0 1 11.84-2.94v-27.42q8.19 2.56 12.65 6.65t4.47 11.39a18.4 18.4 0 0 1-2.92 10.3 44.6 44.6 0 0 1 17.66 8.52c.62-.91 1.2-1.84 1.74-2.8a34.66 34.66 0 0 0 4.46-17.12q.02-12.01-5.26-18.85Zm-44.62-19.18q-8.2-2.55-12.7-6.69t-4.46-11.66q0-8 4.64-12.75t12.48-5.64Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M179.06 9.17C93.55 9.17 24 78.74 24 164.25s69.55 155.08 155.06 155.08h3.43c-2.58-3.43-5.09-6.79-7.5-10-78.12-2.16-141-66.38-141-145 0-80 65.09-145.08 145.08-145.08s145.07 65 145.07 145a144.2 144.2 0 0 1-11.33 56.21 42 42 0 0 1 8.19-.79c1 0 1.92 0 2.87.1a154.4 154.4 0 0 0 10.27-55.52c0-85.51-69.56-155.08-155.08-155.08"
      ></path>
      <path
        style={{ fill: color }}
        d="M344.84 490.85a100.4 100.4 0 0 1-17.29-1.51l-129.14-21.8a38.83 38.83 0 0 1-32-40.24 36 36 0 0 1 42.5-33.95l51.52 8.45-98-130.92a31.7 31.7 0 0 1-5.95-23.08 29.66 29.66 0 0 1 34.75-25.39A31.66 31.66 0 0 1 211.36 235l27.39 36.23v-.13a29.66 29.66 0 0 1 34.75-25.39 31.57 31.57 0 0 1 18.66 10.74 29.29 29.29 0 0 1 34.06-23.43 31.1 31.1 0 0 1 16.28 8.32 26.16 26.16 0 0 1 30.21-20 27.9 27.9 0 0 1 17.74 11.12l68.78 94.1a85.27 85.27 0 0 1 15.66 64.55 79.54 79.54 0 0 1-32.7 52.6l-42 29.61a95.7 95.7 0 0 1-55.35 17.53m-142.51-88.07a25.63 25.63 0 0 0-16.14 5.63 26.09 26.09 0 0 0-9.83 19.4 29.18 29.18 0 0 0 23.75 29.87l129.13 21.81a86.46 86.46 0 0 0 65.2-14.31l42-29.6A69.58 69.58 0 0 0 465 389.53a75.3 75.3 0 0 0-13.87-57L382.4 238.4a17.94 17.94 0 0 0-11.4-7.17 16.16 16.16 0 0 0-19 13.89 17.93 17.93 0 0 0 3.37 13l36.53 50a5 5 0 0 1-8.08 5.91l-45.75-62.6a21.32 21.32 0 0 0-13.56-8.53 19.31 19.31 0 0 0-22.69 16.59 21.36 21.36 0 0 0 4 15.51l35 47.84a5 5 0 1 1-8.07 5.9l-47.13-64.47a21.7 21.7 0 0 0-13.8-8.68 19.67 19.67 0 0 0-23.11 16.89 21.7 21.7 0 0 0 4.07 15.79L290.55 340a5 5 0 0 1-8.08 5.9l-4.42-6.06L203.33 241a21.74 21.74 0 0 0-13.85-8.74 19.65 19.65 0 0 0-23.11 16.89 21.66 21.66 0 0 0 4.08 15.79l105.39 140.81a5 5 0 0 1-4.81 7.93l-63.83-10.47a28 28 0 0 0-4.87-.43"
      ></path>
    </svg>
  );
};

export default ManualIcon;
